import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import ChromeIcon from "../../assets/integration/google_chrome.svg";
import "../../styles/common.css";

type ExtensionProps = {
  isHighRadiusUser: boolean;
};

const DEFAULT_EXTENSION_URL =
  "https://chromewebstore.google.com/detail/pkpchbembjffjfablejijenpkojncgbe?utm_source=item-share-cb";

const HIGHRADIUS_EXTENSION_URL =
  "https://chromewebstore.google.com/detail/7thgear-ez-access/dlfabfekhedicknfhbohdiimajamifpb?authuser=0&hl=en";

const Extension = ({ isHighRadiusUser }: ExtensionProps) => {
  const url = isHighRadiusUser
    ? HIGHRADIUS_EXTENSION_URL
    : DEFAULT_EXTENSION_URL;

  const handleClick = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "36px",
        gap: "60px",
        width: "550px"
      }}
    >
      <Box>
        <Typography className="extension-heading">
          Browser Extension
        </Typography>
        <Typography className="extension-text">
          Download the 7G Extension to enable meeting insights in your browser.
        </Typography>
      </Box>

      <Tooltip title="Download from Chrome Web Store">
        <IconButton
          onClick={handleClick}
          className="extension-button"
        >
          <img src={ChromeIcon} alt={"ChromeIcon"} width={34} height={34} />
          <Box className="extension-text-wrapper">
            <Typography className="extension-download-text">
                Download on the
            </Typography>
            <Typography className="extension-chrome-text">
              Chrome Web Store
            </Typography>
          </Box>
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default Extension;
